import React from 'react';
import { TripSummaryCard } from '@pcln/cards';
import getMediaNode from '../helpers/getMediaNode';
import TripDates, { getDates } from '../helpers/TripDates';
const FLIGHT_START_DATE_LABEL = 'Departure';
const FLIGHT_END_DATE_LABEL = 'Return';
const getHeading = (origin, destination) => {
  return `${origin} - ${destination}`;
};
/** @public */
const UpcomingFlight = ({
  origin,
  destination,
  isOneWay,
  travelStartDate,
  travelEndDate,
  truncateHeading,
  showArrowRight,
  onClick,
  handleSubmitCTA,
  actionText,
  imageUrl,
  buttonNode
}) => {
  const [startDate, endDate] = getDates(travelStartDate, travelEndDate);
  return React.createElement(TripSummaryCard, {
    mediaNode: getMediaNode('FLY', imageUrl),
    mediaNodeBackgroundColor: imageUrl ? 'transparent' : 'primary.light',
    heading: getHeading(origin, destination),
    noTranslateHeading: true,
    caption: `${isOneWay ? 'One way' : 'Round trip'} flight`,
    body: React.createElement(TripDates, {
      startDateLabel: FLIGHT_START_DATE_LABEL,
      endDateLabel: FLIGHT_END_DATE_LABEL,
      startDate: startDate,
      endDate: !isOneWay && endDate
    }),
    truncateHeading: truncateHeading,
    showArrowRight: showArrowRight,
    onClick: onClick,
    handleSubmitCTA: handleSubmitCTA,
    actionText: actionText,
    buttonNode: buttonNode
  });
};
export default UpcomingFlight;